import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * 서비스에서 넘어오는 콘솔 화면(로그인 연동 · 결제)이 쓴다 (#142, #244)
 *
 * 로그인 안 되어 있으면 로그인 화면으로 보내고, 끝나면 **지금 주소 그대로** 돌아온다(#226).
 * 로그인되어 있으면 true.
 */
export const useRequireLogin = (): boolean => {
  const { token, user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || (token && user)) return;
    const back = `${location.pathname}${location.search}`;
    navigate(`/login?redirect=${encodeURIComponent(back)}`, { replace: true });
  }, [loading, token, user, location.pathname, location.search, navigate]);

  return !loading && !!token && !!user;
};
